import {Instance, flow, types as t} from 'mobx-state-tree'
import {Api as GenericApi} from 'common/types/api/generic/api'
import ShiftsTotalReportPage, {DEFAULT_REGION} from './ShiftsTotalReportPage'
import {injectFromEnv} from '../injectors'

const Zone = t.model({
  name: t.string,
  id: t.string,
  status: t.string
})

const Region = t.model({
  name: t.string,
  id: t.string,
  zones: t.array(Zone)
})

const CttStore = injectFromEnv('api')
.named('CttStore')
.props({
  regions: t.array(Region),
  shiftsTotalReportPage: t.optional(ShiftsTotalReportPage, {})
})
  .actions((self) => {
    const actions = {
      initialize: flow(function * () {
        const response: GenericApi['/regions']['GET']['response']  = (yield self.$env.api.ctt.get('/regions')).data
        const regions = yield Promise.all(response.data.map(async (regionData) =>
          Region.create({
            name: regionData.attributes.name,
            id: regionData.id,
            zones: []
          })))

        self.regions.replace(regions)
      }),
      loadRegionZones: flow(function * (regionId: string) {
        const regionToUpdate = self.regions.find((region) => regionId === region.id)

        if (regionId === DEFAULT_REGION || !regionToUpdate || regionToUpdate.zones.length) {
          return undefined
        }

        const zoneResponse: GenericApi['/regions/:regionId/delivery-zones']['GET']['response'] = (
          yield self.$env.api.ctt.get(`/regions/${regionId}/delivery-zones` as '/regions/:regionId/delivery-zones')
        ).data

        regionToUpdate.zones.replace(zoneResponse.data
          .map((zone) => ({
            id: zone.id,
            name: zone.attributes.name,
            status: zone.attributes.status
          })))
      })
    }

    return actions
})
.views((self) => ({
  getRegionById (id: string) {
    return self.regions.find((r) => r.id === id)
  }
}))

export default CttStore
export type CttStoreType = Instance<typeof CttStore>
